import React, { useState } from "react";
import {
  useAddAppointmentByLocationMutation,
  useGetProvidersQuery,
} from "../../redux/service/appointments_service";
import {
  InputField,
  SimpleInputFiled,
} from "../../components/ReactHooksFormFields/inputField";
import { FaSearch } from "react-icons/fa";
import LoadingBar from "../../components/LoadingBar";
import AppointmentProvider from "../Appointments/AppointmentProvider";
import { toast } from "react-toastify";
import { getUser } from "../../userStore";
import MainPageDialog from "../../components/mainPageDialog";
import { useForm, useWatch } from "react-hook-form";
import { hasActionRights } from "../../userStore";
import { getAppointmentSubmitStatus, getAppointmentSuccessMessage } from "../Appointments/appointmentHelpers";
function ProviderSearch() {
  const user = getUser();
  const { control } = useForm({});
  const search = useWatch({ control, name: "search" });
  const [successfulModal, setSuccessfulModal] = useState(false);
  const [selectedProvider, setSelectedProvider] = useState({});
  const [showAppointmentProvider, setShowAppointmentProvider] = useState(false);
  const {
    data,
    refetch,
    isLoading: providerListLoading,
  } = useGetProvidersQuery({ role: 1 });
  const [saveAppointmentByLocation, { isLoading }] =
    useAddAppointmentByLocationMutation();
  const saveAppointmentHandler = async (data) => {
    const body = {
      added_by: "patient",
      location_id: data?.location,
      comments: data?.reason,
      status: getAppointmentSubmitStatus(user?.practice_id),
      pid: user?.pid,
      duration: 15,
      title: "Office Visit",
      start_time: data.selectTime
        ? `${data?.selectTime?.date} ${data?.selectTime?.time}`
        : "",
      user_id: selectedProvider?.id,
      cat_id: data?.cat_id,
      conf_call: data?.conf_call,
      external_guest: data?.external_guest,
    };

    const result = await saveAppointmentByLocation(body);
    if (result.error) {
      toast.error("Failed to save appointment");
    }
    if (result?.data?.code == -1) {
      toast.error(result?.data?.msg);
    }
    if (result.data?.code === 0) {
      toast.success("Appointment saved successfully");
      refetch();
      setSelectedProvider({});
      setShowAppointmentProvider(false);
      //   reset();
      setSuccessfulModal({state:true,appointmentData:result?.data?.data});
    } else{
        toast.error(result?.data?.msg)
    }
  };
   const access = hasActionRights("appointments", "add");
  return (
    <>
      {successfulModal?.state && (
        <MainPageDialog
          title="Appointment"
          modalSize="md"
          maxHeight={true}
          footerList={[
            {
              title: "Ok",
              type: "save",
              action: () => {
                setSuccessfulModal(false);
              },
            },
          ]}
          show={successfulModal}>
          <div className="p-4">
            <div className="text-center">
              <p className="text-lg">Appointment saved successfully</p>
            </div>
            <div>
              <p className="text-start text-red-700 font-bold mt-2 ">
              {getAppointmentSuccessMessage(
                user?.practice_id,
                successfulModal?.appointmentData
              )}
              </p>
            </div>
          </div>
        </MainPageDialog>
      )}
      {showAppointmentProvider ? (
        <AppointmentProvider
          selectedProvider={selectedProvider}
          goBack={() => setShowAppointmentProvider(false)}
          saveAppointmentHandler={saveAppointmentHandler}
          isSaving={isLoading}
        />
      ) : (
        <div className="text-left">
          <div className="w-full bg-gray-100 p-3 flex justify-between">
            <span className="text-xl font-semibold">Provider Search</span>
            <div className="flex items-center">
              <div className="-mt-2 flex items-center">
                <InputField
                  control={control}
                  name="search"
                  height={"h-[30px]"}
                  autoComplete="off"
                />
                <div className="rounded bg-white px-2 py-1 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 h-[28px] mt-2 pt-2 mr-4">
                  <FaSearch />
                </div>
              </div>
              <button
                className="rounded bg-white px-2 py-1 text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                onClick={refetch}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-5 h-5">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
                  />
                </svg>
              </button>
            </div>
          </div>
          {providerListLoading && <LoadingBar />}
          <div className="bg-gray-100 m-5 rounded p-2 ">
            {data
              ?.filter(
                (data) =>
                  data?.User?.name
                    .toLowerCase()
                    .includes(search?.toLowerCase() || "") ||
                  data?.User?.specialty
                    .toLowerCase()
                    .includes(search?.toLowerCase() || "")
              )
              ?.map((v, k) => (
                <div className="flex justify-between bg-white p-3 m-3 items-center">
                  <div>
                    {v?.User?.name}
                    <div className="text-sm text-gray-500">
                      {v?.User?.specialty}
                    </div>
                  </div>
                  {access==1&&<div
                    onClick={() => {
                      setSelectedProvider(v?.User);
                      setShowAppointmentProvider(true);
                    }}
                    className="text-sm bg-blue-600 text-white p-2 cursor-pointer">
                    Request Appointment
                  </div>}
                </div>
              ))}
          </div>
        </div>
      )}
    </>
  );
}

export default ProviderSearch;
